/** Task 1 post-speech silence gate before generate_question (client-side). */

/** Owner target: ~1.0–1.2s speech-turn debounce after final STT. */
export const TASK1_SILENCE_DEBOUNCE_MS = 1200;

/** Delay from last final transcript to first generate_question attempt. */
export function task1GenerateQuestionDelayMs(): number {
  return TASK1_SILENCE_DEBOUNCE_MS;
}

/** Retry once when backend reports missing transcript (DB lag). */
export const TASK1_TRANSCRIPT_MISSING_RETRY_MS = 900;
export const TASK1_TRANSCRIPT_MISSING_MAX_RETRIES = 1;
